import Sound from '../models/sound.es6';

export default class SoundController {
    constructor() {
        this.sound = new Sound();
        this.init();
        
        this.mediaQueryLists = [];
        this.mediaQueries = [];
        this.mediaQueryPause = false;
        this.lastEvent = null;

        this.isRock = false;
        this._onBlur = this._onBlur.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onVisibilityChange = this._onVisibilityChange.bind(this);
        this._mediaQueryListener = this._mediaQueryListener.bind(this);
        
        this._initMediaQueries();
    }

    init() {
        this.sound.load(() => {
            let lastEvent = '';

            window.addEventListener('blur', this._onBlur);
            window.addEventListener('focus', this._onFocus);
            document.addEventListener('visibilitychange', this._onVisibilityChange);
        });
    }

    _initMediaQueries() {
        this.mediaQueries = [
            'print, screen and (min-width: 1280px)',
            'print, screen and (max-width: 1279px) and (min-width: 1001px) and (orientation: landscape)',
            'print, screen and (max-width: 1000px) and (orientation: landscape)',
        ];

        for(const query of this.mediaQueries){
            const mql = window.matchMedia(query);
            mql.addEventListener('change', this._mediaQueryListener);
            this.mediaQueryLists.push(mql);
        }
    }

    _onBlur() {
        if(this.isRock) return;
        this.lastEvent = 'blur';
        this.sound.pauseAll();
    }

    _onFocus() {
        if(this.isRock) return;
        this.lastEvent = 'focus';
        if(!this.mediaQueryPause) this.sound.resumeAll();
    }

    _onVisibilityChange() {
        if(this.isRock) return;

        if(document.hidden){
            if(this.lastEvent !== 'blur') this.sound.pauseAll();
        }
        else{
            if(this.lastEvent !== 'focus' && !this.mediaQueryPause) this.sound.resumeAll();
        }

        this.lastEvent = null;
    }

    _mediaQueryListener() {
        if(this.isRock) return;
        if(!document.hasFocus()) return;
        
        const isMatched = this.mediaQueryLists.some(mql => mql.matches);
        //const isMatched = true;
        
        if(!isMatched){
            this.mediaQueryPause = true;
            this.sound.pauseAll();
        }
        else{
            this.mediaQueryPause = false;
            this.sound.resumeAll();
        }
    }

    progressCheck() {
        const event = new CustomEvent('endLoading');
        this.intervalId = setInterval(() => {
            let progress = this.sound.getLoadProgress();
            document.documentElement.style.setProperty('--progress', `${progress * 100}%`);

            if (progress === 1) {
                clearInterval(this.intervalId);
                document.dispatchEvent(event);
            }
        }, 500);
    }
}
